import './App.css';

function App() {
  return (
    <div className="construction-page">
      <div className="construction-card">
        <div className="icon">&#128679;</div>
        <h1>Under Construction</h1>
        <p>We're working hard to bring you something great.</p>
        <p className="subtext">Check back soon!</p>
      </div>
    </div>
  );
}

export default App;
